class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.detailsContent = this.mainDetailsToggle.querySelector('.mega-menu__content'); // Target the mega menu content specifically
    this.hoverTimeout = null;
    this.isDesktop = window.matchMedia('(min-width: 990px)'); // Common desktop breakpoint

    // Bind methods to ensure 'this' context is correct
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleSummaryClick = this.handleSummaryClick.bind(this);

    this.addHoverListeners();
    this.isDesktop.addEventListener('change', this.addHoverListeners.bind(this)); // Re-add/remove listeners on resize
  }

  addHoverListeners() {
    // Remove existing listeners first to avoid duplicates on resize
    this.summary.removeEventListener('mouseenter', this.handleMouseEnter);
    if (this.detailsContent) {
      this.detailsContent.removeEventListener('mouseenter', this.handleMouseEnter);
    }
    this.mainDetailsToggle.removeEventListener('mouseleave', this.handleMouseLeave); // Listen on the whole <details> for leave
    this.summary.removeEventListener('click', this.handleSummaryClick);

    // Add listeners only if on desktop
    if (this.isDesktop.matches) {
      this.summary.addEventListener('mouseenter', this.handleMouseEnter);
      if (this.detailsContent) {
        this.detailsContent.addEventListener('mouseenter', this.handleMouseEnter);
      }
      this.mainDetailsToggle.addEventListener('mouseleave', this.handleMouseLeave); // Listen on the whole <details> for leave
      this.summary.addEventListener('click', this.handleSummaryClick);
    } else {
      // Ensure click works normally on mobile by potentially removing the preventDefault if added elsewhere
      // The base class or browser default handles mobile clicks
    }
  }

  handleMouseEnter() {
    if (!this.isDesktop.matches) return;
    clearTimeout(this.hoverTimeout);
    if (!this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.setAttribute('open', '');
      // Manually trigger the onToggle logic if needed for animations/styles
      this.onToggle();
    }
  }

  handleMouseLeave() {
    if (!this.isDesktop.matches) return;
    this.hoverTimeout = setTimeout(() => {
      this.close();
    }, 150); // Small delay to allow moving cursor between summary and content
  }

  handleSummaryClick(event) {
    if (!this.isDesktop.matches) return;
    // Prevent default click behavior on desktop, as hover handles opening/closing
    event.preventDefault();
    // Optionally, allow click to close if already open
    // if (this.mainDetailsToggle.hasAttribute('open')) {
    //   this.close();
    // }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.hasAttribute('open'); // Use hasAttribute for check

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }

  close() {
    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.mainDetailsToggle.removeAttribute('open');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', 'false');
      // Manually trigger the onToggle logic if needed for animations/styles
      this.onToggle();
    }
  }
}

customElements.define('header-menu', HeaderMenu);
